import React from 'react'
import './ServiceGrid.scss'
import H2 from '../Fonts/H2/H2'

const ImageGrid = ({data}) => {
    return (
        <div className='image-grid'>
            {data.map(service => {
            return  <a href={`#${service.slug}`} >
                        <div className='grid-poster'>
                            <div className='poster' alt='poster' style={{backgroundImage: `url(${service._embedded["wp:featuredmedia"][0].source_url})`}} />
                            <H2 text={service.title.rendered}/>
                        </div>
                    </a>
            })}
        </div>
    )
}

export default ImageGrid